import { BUTTON_STYLES as inputButtonStyles, INLINE_BUTTON_STYLES } from './types'

const BUTTON_STYLES = { ...inputButtonStyles, ...INLINE_BUTTON_STYLES }

export const getChevronStyling = (style, color, isStories) => {
  if (isStories) {
    return `svg {
      stroke: none !important; fill: none !important;
    }`
  }
  if (style === BUTTON_STYLES.SQUARE_CHEVRON || style === BUTTON_STYLES.SQUARE_ARROW || style === BUTTON_STYLES.SQUARE_FUNK) {
    return `box-shadow: 0px 1px 6px rgba(50, 50, 71, 0.08), 0px 0px 1px rgba(50, 50, 71, 0.2);
        border-radius: 4px;
        background-color: ${color || 'white'};
          ${
            color === 'white' || !color || color === '#ffffff' || color === '#FFFFFF'
              ? 'border: 1px solid rgba(203, 213, 224, 1);'
              : ''
          }
        `
  }
  if (style === BUTTON_STYLES.NONE_CHEVRON || style === BUTTON_STYLES.NONE_ARROW || style === BUTTON_STYLES.NONE_FUNK) {
    return ``
  }
  return `box-shadow: 0px 1px 6px rgba(50, 50, 71, 0.08), 0px 0px 1px rgba(50, 50, 71, 0.2);
        border-radius: 25px;
        background-color: ${color || 'white'};
          ${
            color === 'white' || !color || color === '#ffffff' || color === '#FFFFFF'
              ? 'border: 1px solid rgba(203, 213, 224, 1);'
              : ''
          }
        `
}

export const getChevronImg = (style, widgetChevronPrimaryColor, isStories) => {
  if (isStories) {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM12.7163 4.28831C12.3367 3.90768 11.7191 3.90581 11.3376 4.28479L6.28731 9.3112C5.90583 9.68995 5.90395 10.3061 6.28378 10.687L11.3376 15.7169C11.7191 16.0959 12.3367 16.094 12.7163 15.7134C13.0961 15.3325 13.0942 14.7164 12.7127 14.3376L8.35536 10.0007L12.7127 5.66409C13.0942 5.28534 13.0961 4.66917 12.7163 4.28831Z"
          fill="#FAFAFA"
        />
      </svg>
    )
  }
  if (style && style.includes('ARROW')) {
    return (
      <svg
        width="25"
        height="17"
        viewBox="0 0 25 17"
        fill={widgetChevronPrimaryColor || 'black'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.5 8.5C24.5 8.99092 24.1162 9.38889 23.6429 9.38889L3.42647 9.38889L8.82038 14.9826C9.15511 15.3297 9.15511 15.8925 8.82038 16.2397C8.48564 16.5868 7.94293 16.5868 7.60819 16.2397L0.751051 9.12854C0.416317 8.78141 0.416317 8.21859 0.751051 7.87146L7.60819 0.76035C7.94293 0.413217 8.48564 0.413217 8.82038 0.76035C9.15511 1.10748 9.15511 1.6703 8.82038 2.01743L3.42647 7.61111L23.6429 7.61111C24.1162 7.61111 24.5 8.00908 24.5 8.5Z"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    )
  }
  if (style && style.includes('FUNK')) {
    return (
      <svg
        width="25"
        height="20"
        viewBox="0 0 25 20"
        fill={widgetChevronPrimaryColor || 'black'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4171 0.550328C10.3986 0.531726 9.83109 0.389489 9.15615 0.23436C8.48112 0.0792313 7.92154 -0.023986 7.91254 0.00482488C7.90362 0.0337223 7.83377 0.502223 7.75741 1.046C7.60399 2.13795 7.23254 3.4129 6.83563 4.21026C5.59845 6.69526 3.37873 8.34068 0.686504 8.76835L0.000936508 8.87727V9.97503V11.0729L0.622311 11.1771C4.6933 11.8601 7.34739 14.904 7.84389 19.4593C7.87628 19.7567 7.91502 20 7.92994 20C8.06724 20 10.3422 19.4517 10.3853 19.4083C10.4164 19.3769 10.3932 19.098 10.3338 18.7887C9.67544 15.3637 7.79049 12.5767 5.34442 11.4113L4.75767 11.1318L16.8235 11.1099L24.4531 11.096V8.87431L16.8039 8.8604L4.7665 8.83843L5.50726 8.46311C7.42898 7.48951 8.95045 5.57968 9.84643 3.01621C10.1017 2.2859 10.487 0.620928 10.4171 0.550328Z"
          fill={widgetChevronPrimaryColor || 'black'}
        />
      </svg>
    )
  }
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill={widgetChevronPrimaryColor || 'black'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0303 19.5303C10.7374 19.8232 10.2626 19.8232 9.96967 19.5303L0.96967 10.5303C0.676777 10.2374 0.676777 9.76256 0.96967 9.46967L9.96967 0.469669C10.2626 0.176777 10.7374 0.176777 11.0303 0.469669C11.3232 0.762564 11.3232 1.23744 11.0303 1.53033L2.56066 10L11.0303 18.4697C11.3232 18.7626 11.3232 19.2374 11.0303 19.5303Z"
      />
    </svg>
  )
}

export const getChevronImgSize = (style, isStories) => {
  if (isStories) {
    return '18px'
  }
  if (style === BUTTON_STYLES.NONE_CHEVRON || style === BUTTON_STYLES.NONE_ARROW || style === BUTTON_STYLES.NONE_FUNK) {
    return '24px'
  }
  return '18px'
}
